import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { EquipmentContent } from 'src/app/domains/equipment/models';
import { EquipmentService } from 'src/app/domains/equipment/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'gdp-allocate-to-pbx-popup',
  templateUrl: './allocate-to-pbx-popup.component.html',
  styleUrls: ['./allocate-to-pbx-popup.component.scss']
})
export class AllocateToPbxPopupComponent implements OnInit {
  public equipment: EquipmentContent;
  public loadingAllocate: boolean = false;
  public company: UntypedFormControl;

  @Output() onLoadingAllocate: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onAllocateToPbx: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private activeModal: NgbActiveModal,
    private equipmentService: EquipmentService,
    private notification: NotificationService,
    private translate: TranslateService) { }

  ngOnInit() {
    this.company = new UntypedFormControl(null);
  }

  public allocateToPbx() {
    const company = this.company.value;
    this.loadingAllocate = true;
    this.onLoadingAllocate.emit(this.loadingAllocate);
    this.equipmentService.allocateToPbx(
      company.pbxId,
      this.equipment.mac_address
    ).subscribe(
      (res: any) => {
        this.loadingAllocate = false;
        this.onLoadingAllocate.emit(this.loadingAllocate);
        this.onAllocateToPbx.emit(res);
        this.close();
        this.notification.success(this.translate.instant(
          'equipment.details.modals.allocate-pbx.allocate-success',
          {equipment: this.equipment.mac_address, pbx: company.name}
        ));
      }, () => {
        this.loadingAllocate = false;
        this.onLoadingAllocate.emit(this.loadingAllocate);
        this.close();
      });
  }

  close() {
    this.activeModal.close();
  }
}
